import { jsx as r } from "react/jsx-runtime";
import "react";
var t = (l) => /* @__PURE__ */ r("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 36 36",
  ...l,
  children: /* @__PURE__ */ r("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M32 30a2 2 0 1 1-4 0V9.833L7.576 31.255a2.092 2.092 0 0 1-2.914.1 1.991 1.991 0 0 1-.097-2.856L24.109 8H6a2 2 0 1 1 0-4h24a2 2 0 0 1 2 2v24Z",
    clipRule: "evenodd"
  })
});
export {
  t as default
};
